import React from "react";
import { InventoryInFormModal } from "../InventoryInFormModal";

export function DefectiveReplacementFromCustomerModal({ open, onOpenChange, onSuccess }) {
  return (
    <InventoryInFormModal
      open={open}
      onOpenChange={onOpenChange}
      onSuccess={onSuccess}
      sourceType="Defective_Replacement_From_Customer"
      labelKey="inventory.defectiveReplacementFromCustomer"
    />
  );
}
